import { getBaseRequestUrl, getToken } from './constants'
import { message, notification } from 'antd'
import { IconType } from 'antd/lib/notification'

interface FilrResponse {
    retCode: number
    retData: any
    retMsg: string
    success: boolean
}
interface File {
    uid?: string
    name?: string
    status?: string
    response: FilrResponse
    linkProps?: any
}
interface Upload {
    file: File
    fileList: any
    event: any
}

export const messageConfig = (content: string, duration: number, type: IconType) => {
    notification.open({
        description: '',
        message: content,
        duration: duration,
        type: type,
        style: {
            width: 900,
        },
        placement: 'topRight',
    })
}
//callback  上传返回的数据，  返回undefined 是为拉清楚loading。

export function importPropsConfig1(url: string, callback: any, loadingFn?: () => void): object {
    let cfg = {
        name: 'file',
        action: getBaseRequestUrl() + url,
        timeout: 300000,
        headers: {
            authorization: getToken(),
            timeout: 300000,
        },
        onChange(info: Upload) {
            loadingFn?.()
            try {
                if (info.file.status === 'done' && info.file?.response?.retCode === 200) {
                    let newMessage = info?.file?.response?.retData ? info?.file?.response?.retData.find((item) => item.status === false) : 0
                    if (!newMessage) {
                        message.success({
                            content: `${info.file.name}导入${typeof info?.file?.response?.retData === 'string' ? info?.file?.response?.retData : info.file.response.retMsg
                                }`,
                            duration: 10,
                        })
                    } else {
                        let str: string = ''
                        let total: number = 0
                        let num: number = 0
                        info?.file?.response?.retData.forEach((item, index) => {
                            total += 1
                            if (item.msg !== '新增成功!') {
                                num += 1
                                str += `第${index + 1}条:${item.msg}`
                            }
                        })
                        messageConfig(
                            str
                                ? '共导入' + total + '条，' + num + '条未成功，以下作业信息导入异常：' + str
                                : '共导入' + total + '条，' + num + '条未成功，导入成功',
                            20,
                            'info'
                        )
                    }
                    callback?.(info?.file?.response?.retData)
                } else if (info.file.status === 'error' && info.file.response && info?.file?.response?.retData) {
                    message.error(`${info?.file?.response?.retData}：${info.file.name}导入异常，请尝试重新导入`)
                    callback?.(undefined)
                } else if (info.file.status === 'error') {
                    message.error("导入错误 " + info.file.response.retMsg ?? "");
                    callback?.(undefined);
                } else if (!info.file.status) {
                    callback?.(undefined)
                }
            } catch (error) {
                message.warning('导出异常，请重新尝试')
                callback?.(undefined)
            }
        },
    }
    return cfg
}
